import GoogleLoginButton from './GoogleLoginButton';

export default GoogleLoginButton;
